var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetDirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "detail-panel",
    transform: "translate(-17.000000, -98.000000)",
    fill: "#0091EA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Get-directions",
    transform: "translate(17.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7624902,9.43423121 L8.56226629,2.23400728 C8.25025659,1.92199757 7.74224079,1.92199757 7.43423121,2.23400728 L0.234007278,9.43423121 C-0.0780024259,9.74624091 -0.0780024259,10.2542567 0.234007278,10.5662664 L7.43423121,17.7624902 L7.43423121,17.7664903 C7.74624091,18.0785001 8.25425671,18.0785001 8.56626642,17.7664903 L15.7664903,10.5662664 C16.0785001,10.2502566 16.0785001,9.74624091 15.7624902,9.43423121 Z M9.59829851,11.998311 L9.59829851,9.99824875 L6.39819899,9.99824875 L6.39819899,12.3983234 L4.79814923,12.3983234 L4.79814923,9.19822387 C4.79814923,8.75421006 5.1541603,8.39819899 5.59817411,8.39819899 L9.59829851,8.39819899 L9.59829851,6.39813679 L12.3983856,9.19822387 L9.59829851,11.998311 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetDirections);
export default __webpack_public_path__ + "static/media/getDirections.73dcd7c6476d96288690f99488de12db.svg";
export { ForwardRef as ReactComponent };